import styled from 'styled-components';

export default styled.div`
    .excelExportBtn {
        float: right;
        margin-top: -10px;
    }

    .adaTopContainer {
        display: flex;
    }
    
    .btn-close-container {
        display:flex;
        justify-content: flex-end;
        padding-top: 8px;
    }
    
    .instructions-list {
        line-height: 1.5;
        list-style-position: inside;
        padding-left: 0;
    }
    
    .instructions-list > li::marker {
      font-weight: bold;
    }
    
    .instructions-img {
        width: 30vw;
        padding: 5px;
        margin: 0 auto 15px auto;
        border: 1px solid lightgray;
    }
`;